/**
 * Flex layout shared by the main income table header and data rows. `flexBasis: 0` keeps
 * columns aligned—without it, header cells shrink to label width and no longer match inputs.
 */
export const incomeTableMemberColumnProps = {
    flex: 1,
    flexBasis: 0,
    minWidth: 88,
    width: '100%' as const,
};

export const incomeTableSourceColumnProps = {
    flex: 1.35,
    flexBasis: 0,
    minWidth: 100,
    width: '100%' as const,
};

export const incomeTableAmountColumnProps = {
    flex: 1,
    flexBasis: 0,
    minWidth: 100,
    width: '100%' as const,
};

export const incomeTablePayCycleColumnProps = {
    flex: 1.15,
    flexBasis: 0,
    minWidth: 112,
    width: '100%' as const,
};

/** Bills “All” view: category label between name and amount. */
export const incomeTableBillCategoryColumnProps = {
    flex: 1,
    flexBasis: 0,
    minWidth: 108,
    width: '100%' as const,
};

export const incomeTableIncomeTypeColumnProps = {
    flex: 1.25,
    flexBasis: 0,
    minWidth: 128,
    width: '100%' as const,
};

export const INCOME_TABLE_ACTIONS_OUTER_WIDTH = 56;

/**
 * Horizontal inset for title/footer text and buttons (matches former card `padding`).
 * Table rows are full-bleed inside the card; row content uses
 * {@link INCOME_TABLE_ROW_PADDING_HORIZONTAL} so columns stay aligned.
 */
export const INCOME_TABLE_CARD_EDGE_PADDING = 24;

/** Former card edge padding + row-only horizontal padding — keeps inputs aligned with column headers. */
export const INCOME_TABLE_ROW_PADDING_HORIZONTAL =
    INCOME_TABLE_CARD_EDGE_PADDING + 4;

/**
 * Row is not being edited — transparent 1px top/bottom so layout matches
 * {@link incomeTableRowFocusActive} and focus changes do not reflow the table.
 */
export const incomeTableRowFocusIdle = {
    backgroundColor: 'transparent',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
} as const;

/** Row has focus-within (editing) or is the add-income row — grey rules + off-white fill. */
export const incomeTableRowFocusActive = {
    backgroundColor: '#FCFCFC',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderTopColor: '#E4E4E4',
    borderBottomColor: '#E4E4E4',
} as const;
